import { Component, OnInit } from '@angular/core';
import { PronunciationService , Pronunciation } from '../../services/pronunciation.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pronunciation-edit',
  templateUrl: './pronunciation-edit.component.html',
  styleUrls: ['./pronunciation-edit.component.css']
})
export class PronunciationEditComponent implements OnInit {

  constructor(public pronunciationSvc: PronunciationService,
    private dialog: MatDialogRef<PronunciationEditComponent>,) { }

  public item: Pronunciation;

  ngOnInit(): void {
  }

  public loadEntity(entity: Pronunciation) {
    console.log("loadEntity", entity);

    
    this.item = Object.assign({}, entity);
    
  }


  public save() {
    console.log("save");
  
    this.pronunciationSvc.save(this.item).then(
      (data: Pronunciation) => {   
        this.dialog.close(true);
      },
      (err) => {
        alert("Error while saving the Proper: " + err.Message);
        console.log("error", err); 
      }
   );

  }

  public cancel() {
    this.dialog.close();
  }
}
